import { message } from 'antd';
import egresadosApi from "../../api/Alumno/egresadosApi";
import alerts from '../../../../shared/alerts';


export default {
    getProfileEgresados: async () => {
        const response = await egresadosApi.getProfileEgresados();
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    validateEgresadoSirExistence: async (data) => {
        const response = await egresadosApi.validateEgresadoSirExistence(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    registerEgresado: async (data) => {
        const response = await egresadosApi.registerEgresado(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    registerEgresadoMatriculaAntigua: async (data) => {
        const response = await egresadosApi.registerEgresadoMatriculaAntigua(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    uploadImageProfile: async (file) => {
        const response = await egresadosApi.uploadImageProfile(file);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    updateInformacion: async (data) => {
        const response = await egresadosApi.updateInformacion(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    uploadImageCover: async (file) => {
        const response = await egresadosApi.uploadImageCover(file);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    getImagen: async (filename) => {
        const response = await egresadosApi.getImagen(filename);
        return response;
    },
    deleteImage: async (type_file) => {
        const response = await egresadosApi.deleteImage(type_file);
        return response;
    },
    getCvPdf: async (values) => {
        const response = await egresadosApi.getCvPdf(values);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    /* Metodos solo para administradores */
    adminUpdateEgresado: async (data) => {
        const response = await egresadosApi.adminUpdateEgresado(data);
        if (!response.success) {
            alerts.error(response.message);
        }else{
            alerts.success(response.message);
        }
        return response;
    }
}
